import { motion } from "framer-motion";
import { FaLeaf, FaLock, FaGasPump } from "react-icons/fa";
import FAQ from './FAQ';
import { FaScroll, FaWallet, FaCheckCircle } from 'react-icons/fa';
import Ev_Charging from '../assets/EV-Chargins-Station.png';
import { Link } from 'react-router-dom';
import Header from "./Header";
import Footer from "./Footer";

const Evstations = () => {
   return (
      <>
         <Header />

         {/* Hero Section */}
         <div className="bg-[#f3f0eb]">
            <section className="relative flex flex-col md:flex-row items-center justify-between max-w-7xl mx-auto px-4 py-12">
               <motion.div
                  initial={{ opacity: 0, x: -50 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8 }}
                  className="md:w-1/2 space-y-6"
               >

                  <h2 className="text-4xl md:text-5xl font-extrabold leading-tight text-[#1a4632] mb-8">
                     EV <span className="text-[#9cc026]">Charging Station</span>
                  </h2>

                  <p className="text-lg md:text-xl mb-6">
                     Turn your recycling into rewards and use them to power your EV at participating charging stations.
                  </p>

                  <div className="mt-8">
                     <Link
                        to="/register"
                        className="inline-block px-6 py-2 bg-gradient-to-r from-green-400 to-green-600 text-white text-lg font-semibold rounded-2xl shadow-lg hover:shadow-green-500/50 hover:scale-105 transition-all duration-300"
                     >
                        Get Started
                     </Link>
                     <p className="mt-2 text-sm text-gray-600 italic">
                        No hidden fees. Simple rewards. Eco-friendly impact.
                     </p>
                  </div>
               </motion.div>

               <motion.div
                  initial={{ opacity: 0, x: 50 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8 }}
                  className="md:w-1/2 flex justify-center mt-10 md:mt-0"
               >
                  <img
                     src={Ev_Charging}
                     alt="Fuel Savings"
                     className="w-80 md:w-[400px] drop-shadow-xl"
                  />
               </motion.div>
            </section>
         </div>

         {/* How It Works */}
         <section className="bg-white py-16">
            <div className="max-w-3xl mx-auto space-y-4">

               <h2 className="text-3xl md:text-4xl font-bold text-center text-[#1a4632] mb-6">
                  How FareFuel <span className="text-[#9cc026]">Works</span>
               </h2>

               <p className="text-center text-gray-600">
                  A simple way to turn recycling rewards into EV charging credits.
               </p>

               <FAQ
                  question={
                     <span className="flex items-center gap-2">
                        <FaScroll className="text-[#794f00]" /> Recycle & Earn
                     </span>
                  }
                  answer={
                     <p className="mb-2">
                        Drop off recyclables at FareFuel centers. Items are scanned and rewards are added to your account.
                     </p>
                  }
               />

               <FAQ
                  question={
                     <span className="flex items-center gap-2">
                        <FaWallet className="text-[#1a4632]" /> Track Your Rewards
                     </span>
                  }
                  answer={
                     <p className="mb-2">
                        Your rewards balance updates automatically. Track your activity anytime through the app or website.
                     </p>
                  }
               />

               <FAQ
                  question={
                     <span className="flex items-center gap-2">
                        <FaCheckCircle className="text-green-600" /> Charge with Credits
                     </span>
                  }
                  answer={
                     <p className="mb-2">
                        Use your rewards credits at participating EV charging stations directly from the app or kiosk.
                     </p>
                  }
               />

            </div>
         </section>

         {/* Why It Matters */}
         <section className="py-16 px-6 bg-[#f0fdf4]">
            <div className="max-w-7xl mx-auto text-center mb-12">
               <h2 className="text-3xl md:text-4xl font-bold text-center text-[#1a4632] mb-6">
                  Why It <span className="text-[#9cc026]">Matters</span>
               </h2>
            </div>

            <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
               {[
                  {
                     icon: <FaGasPump className="text-green-600 text-4xl mb-4" />,
                     title: "Earn Fuel Savings",
                     desc: "Your recycling rewards help reduce your fuel or charging costs."
                  },
                  {
                     icon: <FaLeaf className="text-green-600 text-4xl mb-4" />,
                     title: "Support Sustainability",
                     desc: "Turn everyday recycling into meaningful environmental impact."
                  },
                  {
                     icon: <FaLock className="text-green-600 text-4xl mb-4" />,
                     title: "Simple & Secure",
                     desc: "Track your rewards and use them easily at participating stations."
                  }
               ].map((card, idx) => (
                  <motion.div
                     key={idx}
                     whileHover={{ y: -5 }}
                     className="bg-[#ECFFDC] border border-[#25994c] rounded-lg p-6 shadow-sm transition duration-300 ease-in-out hover:shadow-[0_8px_30px_4px_rgba(116,175,32,0.4)]"
                  >
                     {card.icon}
                     <h3 className="text-xl font-semibold mb-2">{card.title}</h3>
                     <p className="text-gray-600">{card.desc}</p>
                  </motion.div>
               ))}
            </div>
         </section>

         {/* Coming Soon */}
         <section className="py-12 px-6 bg-[#9cc026] text-white text-center">
            <motion.h3
               initial={{ opacity: 0 }}
               animate={{ opacity: 1 }}
               transition={{ duration: 1 }}
               className="text-2xl md:text-3xl font-bold mb-4"
            >
               🚗 Coming Soon
            </motion.h3>
            <p className="text-lg max-w-3xl mx-auto">
               We’re expanding our EV station network every month.
               Check the app or website for new locations near you.
            </p>
         </section>
         <Footer />
      </>
   );
};

export default Evstations;

